import PaymentIcon from '@mui/icons-material/Payment';
import CreditCardOffIcon from '@mui/icons-material/CreditCardOff';
import Fade from '@mui/material/Fade';
import * as theme from '../../../theme';

export default function CreditCardItem({ children, ...props }) {

  return (
    <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 3 }}>
      <div className={props.actionLink ? 'cardLink' : 'cardLinkDisabled' } style={{ display: 'flex', flex: 3, width: '100%', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }} onClick={() => props.actionLink != null ? props.actionLink() : null}>
        <div style={{ ...theme.Container.flexRowFixed, padding: 8 }}>
          {props.card.enabled ? (
            <PaymentIcon sx={{ fontSize: 24 }} />
          ) : (
            <CreditCardOffIcon sx={{ fontSize: 24 }} />
          )}
          <div style={{ flex: 1, fontSize: 14, fontWeight: 500 }}>
            {props.card.brand} x{props.card.last4}
            <br />
            <Fade in={true} timeout={300}>
              <span style={{ fontWeight: 'normal', fontSize: '0.85em', color: theme.Colors.GrayMedium }}>
                Expires {props.card.expMonth}/{String(props.card.expYear).slice(-2)}
              </span>
            </Fade>
          </div>
        </div>
      </div>
    </div>
  );
}